import React from 'react'
import { RootPage } from 'src/components/Reusable/RootPage'
import {
  SubRoutes,
  ROOT_ID_PARAM_TYPE,
} from '../../components/Reusable/RootPage/RootPage.constants'
import { RisksIndexPage } from './index/RisksIndexPage'
import { RisksShowPageRouter } from './show/RisksShowPageRouter'
import { RisksProvider } from './context/RisksContext'

export const RisksRootPage = (): JSX.Element => {
  return (
    <RisksProvider>
      <RootPage
        idParamType={ROOT_ID_PARAM_TYPE.RISK_ID}
        indexRoute={SubRoutes.INDEX}
        indexPage={<RisksIndexPage />}
        showRoute={SubRoutes.SHOW}
        showPage={<RisksShowPageRouter />}
      />
    </RisksProvider>
  )
}
